// Central de Indicações — só leitura (o app nunca muda etapa).
import { useQuery } from "@tanstack/react-query";
import { gpsDriveReferralsService, type ReferralStatus } from "@/services/gpsdrive-referrals.service";

export const useReferralSummary = () =>
  useQuery({ queryKey: ["referrals", "summary"], queryFn: gpsDriveReferralsService.summary, retry: 1 });

export const useReferralList = (status?: ReferralStatus) =>
  useQuery({
    queryKey: ["referrals", "list", status ?? "all"],
    queryFn: () => gpsDriveReferralsService.list(status),
    retry: 1,
  });

export const useReferralDetail = (id: string | null) =>
  useQuery({
    queryKey: ["referrals", "detail", id],
    queryFn: () => gpsDriveReferralsService.detail(id as string),
    enabled: !!id,
    retry: 1,
  });
